module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ruido Perla NFT Collection","short_name":"Ruido Perla","start_url":"/","background_color":"#e1f7f5","theme_color":"#533777","display":"standalone","icon":"static/images/favicon.png","icons":[{"src":"static/images/favicon-192x192.png","sizes":"192x192","type":"image/png","purpose":"any maskable"},{"src":"static/images/favicon-512x512.png","sizes":"512x512","type":"image/png","purpose":"any maskable"}],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"6badec06c2b47a68a0a309f9e3c218cd"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
